import { yup } from '@framework/validation/initYup.ts';

/**
 * Gruppo tematico per i layer della mappa.
 * I layer referenziano il gruppo tramite il campo `group` (che corrisponde al `name`).
 */
export interface IMapGroup {
  /** Identificatore univoco del gruppo (referenziato da IMapLayer.group) */
  name: string;
  /** Etichetta visibile nel pannello livelli (default = name) */
  label?: string | null;
  /** Descrizione opzionale, mostrata in tooltip */
  description?: string | null;
  /** Se `true`, il gruppo è espanso di default nel pannello livelli */
  expandedByDefault?: boolean;
  /** Ordine del gruppo nel pannello livelli */
  order?: number | null;
}

export const MapGroupSchema = yup
  .object({
    name: yup
      .string()
      .required()
      .label('Nome Gruppo')
      .matches(
        /^[a-zA-Z]([a-zA-Z0-9_-]*)$/,
        'Il nome deve iniziare con una lettera e può contenere solo lettere, numeri, - e _',
      )
      .test(
        'unique-name',
        'Esiste già un gruppo con questo nome',
        (value, context) => {
          const existingNames: string[] =
            context.options.context?.existingGroupNames ?? [];
          return !(value && existingNames.includes(value));
        },
      ),
    label: yup.string().notRequired().nullable().label('Etichetta'),
    description: yup.string().notRequired().nullable().label('Descrizione'),
    expandedByDefault: yup.boolean().default(true).label('Espanso di default'),
    order: yup
      .number()
      .integer()
      .min(0)
      .notRequired()
      .nullable()
      .label('Ordine'),
  })
  .noUnknown()
  .required();
